import React, { FunctionComponent } from 'react';
import { cn } from '../../../utilities/cn';

interface RSCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
}

const RSCard: FunctionComponent<RSCardProps> = ({ children, ...props }) => {
  return (
    <div
      {...props}
      className={cn(
        'rounded-md border border-gray-200 bg-white p-4 shadow-sm',
        props.className,
      )}
    >
      {children}
    </div>
  );
};

export default RSCard;
